<template>
    <ui-modal
        :title="editMode ? 'Editar categoria de unidade' : 'Adicionar categoria de unidade'"
        icon="far fa-cog"
        name="modal-unity-values-add-category"
        size="xxs">
        <div class="modal-content">
            <!-- @start .register-categories-form -->
            <form class="register-categories-form">
                <ui-input v-model="form.data.name" required type="text" label="Nome" value="a" />

                <ui-input v-model="form.data.weight" required type="number" label="Peso em %" group="%" />

                <ui-color-picker v-model="form.data.color" label="Cor" />

                <div class="label">Exemplo de Legenda:</div>
                <ui-badge :abbreviation="form.data.name" :color="form.data.color" />
            </form>
            <!-- @end .register-categories-form -->
        </div>

        <template #footer>
            <ui-button v-if="editMode" design="success lg" @click="saveCategories">
                Adicionar categoria
            </ui-button>
            <ui-button v-else design="success lg" @click="editCategory(productCategory.id)">
                Editar Categoria
            </ui-button>
        </template>
    </ui-modal>
</template>
<script>
	import { uiInput, uiColorPicker } from '@/components/ui/form'
	import { uiButton } from '@/components/ui/buttons'
	import { uiModal } from '@/components/ui/modal'
	import uiBadge from '@/components/ui/badge'
	import { groupsAvailability } from '@/services/axios'
	import { mapGetters } from 'vuex'

	export default {
		name:"unity-value",
		components: {
			uiInput,
			uiColorPicker,
			uiModal,
			uiBadge,
			uiButton,
		},

		props: {},
		data() {
			return {
				iscolor: false,
				editMode: null,
				categorys: [],
				form: {
					fields: {
						name: {
							required: true,
							disabled: false,
						},
					},
					data: {
						name: null,
						weight: null,
						color: '#3B4350',
					},
					unsubscribe: null,
				},
			}
		},
		computed: {
			...mapGetters('productCategory', {
				productCategory: 'getProductCategory',
				productCategorys: 'getProductCategorys',
				productAvailability: 'getProductAvailability',
			}),
		},
		mounted() {
			this.$root.$on('modal-open-modal-unity-values-add-category', (payload) => {
				if (!payload) {
					this.editMode = false
					this.form.data = this.productCategory
				} else {
					this.editMode = true
				}
			})
			this.$root.$on('modal-close-modal-unity-values-add-category', () => {
				this.form.data.name = null
				this.form.data.weight = null
				this.form.data.color = '#3B4350'
			})
		},

		methods: {
			saveCategories() {
				let data = {
					name: this.form.data.name,
					weight: this.form.data.weight,
					color: this.form.data.color,
					availability_id: this.productAvailability.id,
				}

				groupsAvailability
					.create('', data)
					.then((response) => {
						this.$store.dispatch('productCategory/savedProductCategory', response.data.data)
						this.$root.$emit('modal-close-modal-unity-values-add-category')
						this.$toastr.s(response.data.msg)
					})
					.catch((error) => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						console.log(error)
					})
			},

			editCategory(id) {
				let data = {
					name: this.form.data.name,
					weight: this.form.data.weight,
					color: this.form.data.color,
				}

				groupsAvailability
					.update('', id, data)
					.then((response) => {
						this.$store.dispatch('productCategory/updateProductCategory', response.data.data)
						this.$root.$emit('modal-close-modal-unity-values-add-category')
						this.$toastr.s(response.data.msg)
					})
					.catch((error) => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						console.log(error)
					})
			},

			showColorPicker() {
				this.iscolor = true
			},

			hideColorPicker() {
				this.iscolor = false
			},

			updateColor(val) {
				this.form.data.color = val.hex
			},

			close() {
				this.$root.$emit('modal-close-modal-unity-values-add-category')
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
